const _ = require('lodash');

const parseQueryString = function( queryString ) {
  var params = {}, queries, temp, i, l;
  // Split into key/value pairs
  queries = queryString.replace('?','').split("&");
  // Convert the array of strings into an object
  for ( i = 0, l = queries.length; i < l; i++ ) {
      temp = queries[i].split('=');
      params[temp[0]] = temp[1];
  }
  return params;
};
exports.parseQueryString = parseQueryString;

const getQueryString = function(searchKeys) {
  return _.reduce(searchKeys, function (str, val, key) {
    if (!val) {
      return str;
    } else if (str.length <= 0) {
      return key + '=' + val;
    } else {
      return str + '&' + key + '=' + val;
    }
  }, '');
};
exports.getQueryString = getQueryString;

const urlHashToObject = function () {
  if ('object' !== typeof(location)) {
    console.log('Called fn urlHashToObject with window.location out of scope. Returned empty.');
    return {};
  }
  const cleanHash = location.hash.split('?')[0];
  const hashValue = cleanHash.slice(1);
  const whatsInHash = hashValue.split('&');
  const returnObj = {};
  _.forEach(whatsInHash, function (value) {
    const hashBlock = value.split('=');
    returnObj[hashBlock[0]] = hashBlock[1];
  });
  return returnObj;
};
exports.urlHashToObject = urlHashToObject
